/*
 * @Author: lc 2631402207@qq.com
 * @Date: 2025-07-07 16:28:07
 * @LastEditors: lc 2631402207@qq.com
 * @LastEditTime: 2025-11-17 15:27:26
 * @FilePath: \ui\src\api\chat.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { BASE_URL } from '../const'
import { fetchEventSource } from '@microsoft/fetch-event-source'
export const getChat = async (
  callback?: (value: any) => void,
  params?: any,
  mode: string = 'merged'
): Promise<Response> => {
  const controller = new AbortController()
  const signal = controller.signal
  let thinkContent = ''
  let content = ''
  let onlineContent = ''
  let isFinished = false
  await fetchEventSource(BASE_URL + '/chat/flux-sse', {
    method: 'POST',
    signal: signal,
    openWhenHidden: true,
    retry: false,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'text/event-stream',
      'Cache-Control': 'no-cache',
      Connection: 'keep-alive',
      Authorization: localStorage.getItem(import.meta.env.VITE_TOKEN_KEY) || '',
    },
    body: JSON.stringify(params),
    onopen(response) {
      // 连接成功时触发
      if (response.ok) return
      else {
        throw new Error(`连接失败: ${response.status}`)
      }
    },
    onmessage(event) {
      // 处理每个数据块
      try {
        const data = JSON.parse(event.data)
        if (data.content) {
          if (mode === 'raw') {
            callback(data) // 原始事件
          } else {
            if (data.state === 'THINKING') thinkContent += data.content
            else if (data.state === 'ANSWERING') content += data.content
            else if (data.state === 'ONLINE_SEARCH')
              onlineContent += data.content
            else if (data.state === 'DONE') isFinished = true
            callback({ thinkContent, content, onlineContent, isFinished })
          }
        }
        // 标记请求完成
        if (data.state === 'DONE') {
          controller.abort()
        }
      } catch (error) {
        console.error('Parse message failed:', error)
      }
    },
    onclose() {
      // 连接关闭时触发
      console.log('连接终止')
      controller.abort()
    },
    onerror(err) {
      // 错误处理（默认会抛出异常并自动重试）
      console.error('错误:', err)
      throw err // 抛出错误会触发重试机制
    },
  })

  // await reader.read().then(function process({ done, value }) {
  //   if (done) return
  //   callback?.(value)
  //   return reader.read().then(process)
  // })

  // return res
}
